import { useEffect } from "react";
import "./Bridge.css";

const WEB_PAGE_PATH = "/bokiori";

const OG_TITLE = "시간 투자 대비 초고소득 앱테크 - 복이오리";
const OG_DESCRIPTION =
  "앱테크 최대 보상, 현금과 1대1 비율, 특별응모권까지 다양한 혜택이 존재하는 복이오리, 지금 바로 시작하고 다양한 혜택 받아가세요";
const OG_IMAGE_PATH = "/bokiori-assets/bokiori_thumbnail.png";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function Bridge2() {
  const goWebPage = () => {
    const queryString = window.location.search;
    window.location.href = queryString
      ? `${WEB_PAGE_PATH}${queryString}`
      : WEB_PAGE_PATH;
  };

  useEffect(() => {
    const prevTitle = document.title;
    document.title = OG_TITLE;
    upsertMeta("property", "og:title", OG_TITLE);
    upsertMeta("property", "og:description", OG_DESCRIPTION);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "description", OG_DESCRIPTION);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", OG_TITLE);
    upsertMeta("name", "twitter:description", OG_DESCRIPTION);

    if (OG_IMAGE_PATH) {
      const imageUrl = `${window.location.origin}${OG_IMAGE_PATH}`;
      upsertMeta("property", "og:image", imageUrl);
      upsertMeta("name", "twitter:image", imageUrl);
    }

    return () => {
      document.title = prevTitle;
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      goWebPage();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bridge-container">
      <div className="bridge-content">
        <h1 className="bridge-title">페이지로 이동 중...</h1>
        <p className="bridge-message">잠시만 기다려주세요.</p>
        <button className="bridge-button" onClick={goWebPage}>
          복이오리 홈으로
        </button>
      </div>
    </div>
  );
}

export default Bridge2;
